export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer repeated the content appropriately.",
			},
			{
				id: 3,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 4,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 5,
				text: "The lecturer provided the opportunity to discuss the content.",
			},
			{
				id: 6,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 7,
				text: "The lecturer was very competent.",
			},
			{
				id: 8,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 9,
				text: "It was important to the lecturer that the participants benefitted from the course.",
			},
			{
				id: 10,
				text: "The lecturer motivated the participants.",
			},
			{
				id: 11,
				text: "The learning objective was clear to me.",
			},
			{
				id: 12,
				text: "The educational objectives were well deﬁned from the beginning.",
			},
			{
				id: 13,
				text: "The tutorial was clear and understandable.",
			},
			{
				id: 14,
				text: "The content structure of the tutorial was logical/comprehensible.",
			},
			{
				id: 15,
				text: "I was already interested in the topic before the tutorial.",
			},
			{
				id: 16,
				text: "The required prior knowledge is appropriate.",
			},
			{
				id: 17,
				text: "The proportions of mathematical/technical content are appropriate.",
			},
			{
				id: 18,
				text: "The topic of the tutorial is relevant.",
			},
			{
				id: 19,
				text: "I believe that I have learned important facts in the tutorial.",
			},
			{
				id: 20,
				text: "The topic of the course is relevant for my future professional goals.",
			},
			{
				id: 21,
				text: "The diﬃculty of the content was adequate.",
			},
			{
				id: 22,
				text: "The amount of the content was adequate.",
			},
			{
				id: 23,
				text: "The pace of the tutorial was appropriate.",
			},
			{
				id: 24,
				text: "The requirements of the tutorial were appropriate.",
			},
			{
				id: 25,
				text: "The amount of time required for the tutorial (including preparation and follow-up) was appropriate.",
			},
			{
				id: 26,
				text: "Overall, this tutorial demanded too much from me.",
			},
			{
				id: 27,
				text: "This tutorial demanded too little from me.",
			},
			{
				id: 28,
				text: "The quality of the media used in the tutorial was good.",
			},
			{
				id: 29,
				text: "Enough materials were oﬀered to deepen my understanding of the topic.",
			},
			{
				id: 30,
				text: "Presentations and scripts were made available in time.",
			},
			{
				id: 31,
				text: "The prepared presentations helped to deepen my understanding of the topic.",
			},
			{
				id: 32,
				text: "The available materials were ideal for reviewing the tutorial.",
			},
			{
				id: 33,
				text: "The tutorial was helpful to me.",
			},
			{
				id: 34,
				text: "The tutorial deepened my understanding of the contents.",
			},
			{
				id: 35,
				text: "I was encouraged by the tutorial to critically examine the topics covered.",
			},
			{
				id: 36,
				text: "The content of the tutorial was clarified through examples.",
			},
			{
				id: 37,
				text: "The importance of the topics covered was conveyed within the tutorial.",
			},
			{
				id: 38,
				text: "During the tutorial, theory and practical application were put into relation to each other.",
			},
			{
				id: 39,
				text: "Overall, this was a good tutorial.",
			},
			{
				id: 40,
				text: "I learned a lot in this tutorial.",
			},
			{
				id: 41,
				text: "The tutorial fulﬁlled my expectations.",
			},
			{
				id: 42,
				text: "I would recommend the tutorial.",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 43,
				text: "Overall, I evaluate the tutorial with the grade",
				label: [
					{
						id: 1,
						text: "A",
					},
					{
						id: 2,
						text: "B",
					},
					{
						id: 3,
						text: "C",
					},
					{
						id: 4,
						text: "D",
					},
					{
						id: 5,
						text: "E",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 44,
				text: "Further remarks on the tutorial (praise/criticism)",
			},
		],
	},
	{
		type: "age",
		id: 4,
		items: [
			{
				id: 45,
				text: "Age: ",
			},
		],
	},
];
